import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a99c210"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ue-box"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "peerStatus",
  drag: ""
};
const _hoisted_4 = {
  class: "login-type"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-fangxiang-you-mian-xiao"
}, null, -1));
const _hoisted_6 = {
  class: "status-name"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  class: "wtue wtue-fangxiang-xia-mian-xiao"
};
const _hoisted_9 = {
  class: "status-name-text ue-call-variable"
};
const _hoisted_10 = {
  class: "dialState-box"
};
const _hoisted_11 = {
  class: "call-btn-right"
};
const _hoisted_12 = {
  class: "customer-info",
  drag: ""
};
const _hoisted_13 = {
  class: "customer-item"
};
const _hoisted_14 = {
  class: "customer-name"
};
const _hoisted_15 = {
  class: "time"
};
const _hoisted_16 = {
  class: "customer-item"
};
const _hoisted_17 = {
  class: "region"
};
const _hoisted_18 = {
  class: "quick-operation-box drag",
  drag: ""
};
const _hoisted_19 = {
  class: "quick-btn"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-item hangup"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-guaji1"
})], -1));
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = {
  key: 0,
  class: "btn-item hangup"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-guaji1"
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-hujiaohuojieting"
}, null, -1));
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  key: 0,
  class: "error"
};
const _hoisted_28 = {
  class: "opacity80"
};
const _hoisted_29 = {
  class: "oprate-wrap link-hangup"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-guaji1 right8 font12"
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-hujiaohuojieting right8 font12"
}, null, -1));
const _hoisted_32 = {
  class: "oprate-wrap link-oprate"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-a-jiantou-zuo-line"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "返回", -1));
const _hoisted_35 = [_hoisted_33, _hoisted_34];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-a-jiantou-zuo-line"
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "返回", -1));
const _hoisted_38 = [_hoisted_36, _hoisted_37];
const _hoisted_39 = {
  class: "oprate-wrap link-oprate"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-baochi"
}, null, -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "保持", -1));
const _hoisted_42 = [_hoisted_40, _hoisted_41];
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-quxiaobaochi"
}, null, -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "取消保持", -1));
const _hoisted_45 = [_hoisted_43, _hoisted_44];
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-jingyin"
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "静音", -1));
const _hoisted_48 = [_hoisted_46, _hoisted_47];
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-quxiaojingyin"
}, null, -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "取消静音", -1));
const _hoisted_51 = [_hoisted_49, _hoisted_50];
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-jiehui"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "接回", -1));
const _hoisted_54 = [_hoisted_52, _hoisted_53];
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-zixun"
}, null, -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "咨询", -1));
const _hoisted_57 = [_hoisted_55, _hoisted_56];
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-quxiaozixun"
}, null, -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "取消咨询", -1));
const _hoisted_60 = [_hoisted_58, _hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-quxiaozixun"
}, null, -1));
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "取消咨询", -1));
const _hoisted_63 = [_hoisted_61, _hoisted_62];
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-zixunzhuanyi"
}, null, -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "咨询转移", -1));
const _hoisted_66 = [_hoisted_64, _hoisted_65];
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-sanfangtonghua"
}, null, -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "三方通话", -1));
const _hoisted_69 = [_hoisted_67, _hoisted_68];
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-zhuanjie"
}, null, -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "转接", -1));
const _hoisted_72 = [_hoisted_70, _hoisted_71];
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-manyidu"
}, null, -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "满意度", -1));
const _hoisted_75 = [_hoisted_73, _hoisted_74];
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-jianpan"
}, null, -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "键盘", -1));
const _hoisted_78 = [_hoisted_76, _hoisted_77];
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-quxiaojianpan"
}, null, -1));
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "取消键盘", -1));
const _hoisted_81 = [_hoisted_79, _hoisted_80];
const _hoisted_82 = {
  key: 1
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-a-jiantou-zuo-line"
}, null, -1));
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "返回", -1));
const _hoisted_85 = [_hoisted_83, _hoisted_84];
const _hoisted_86 = {
  key: 2
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-a-jiantou-zuo-line"
}, null, -1));
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "返回", -1));
const _hoisted_89 = [_hoisted_87, _hoisted_88];
const _hoisted_90 = {
  key: 3,
  class: "dial"
};
const _hoisted_91 = {
  class: "dial-input"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#wtue-jianpanshanchu"
}, null, -1));
const _hoisted_93 = [_hoisted_92];
const _hoisted_94 = {
  class: "call-btn",
  style: {
    "color": "rgb(28, 146, 233)",
    "font-weight": "600",
    "font-size": "16px"
  }
};
const _hoisted_95 = {
  key: 0,
  class: "dial-box"
};
const _hoisted_96 = ["onClick"];
const _hoisted_97 = {
  key: 4,
  class: "setting"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "通话设置", -1));
const _hoisted_99 = {
  key: 1
};
const _hoisted_100 = {
  class: "footer"
};
const _hoisted_101 = {
  key: 1,
  class: "error-msg"
};
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "error-txt"
}, "您的座席账号正在别处登录，当前页面电话条已退出，请刷新页面重新登录", -1));
const _hoisted_103 = [_hoisted_102];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_phoneBarTimer = _resolveComponent("phoneBarTimer");
  const _component_el_link = _resolveComponent("el-link");
  const _component_transferOprate = _resolveComponent("transferOprate");
  const _component_consuleOprate = _resolveComponent("consuleOprate");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_formItem = _resolveComponent("formItem");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_input_suffix = _resolveComponent("input-suffix");
  const _component_el_button = _resolveComponent("el-button");
  const _component_callQueue = _resolveComponent("callQueue");
  const _component_networkDelay = _resolveComponent("networkDelay");
  const _component_translationTxt = _resolveComponent("translationTxt");
  const _directive_int = _resolveDirective("int");
  const _directive_move = _resolveDirective("move");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.kickDestroy ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'ue-red-border': _ctx.stateType == 'busy',
      'ue-success-border': _ctx.stateType == 'free',
      'phone-bar': true,
      'ue-call-variable': true
    })
  }, [_withDirectives(_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["middle ue-pointer", {
      'ue-red-border': _ctx.stateType == 'busy',
      'ue-success-border': _ctx.stateType == 'free'
    }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.goToSetting && _ctx.goToSetting(...args), ["stop"]))
  }, [_createTextVNode(_toDisplayString(_ctx.loginTypeMap[_ctx.loginType]) + " ", 1), _hoisted_5], 2)], 512), [[_vShow, !_ctx.showConfig && !_ctx.disabledSwitch]]), _createElementVNode("div", {
    class: _normalizeClass(["peerStatus-center", _ctx.stateType])
  }, [_createVNode(_component_el_dropdown, {
    class: "ue-pointer",
    onCommand: _ctx.updateAgentStatus,
    trigger: "click",
    disabled: _ctx.disabledSwitch,
    style: {
      "min-width": "55px"
    }
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      "visible-arrow": false,
      class: "cep-dropdown-menu ue-phoneMenu"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentStatusList, item => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.number,
          command: item.number,
          class: _normalizeClass({
            'hide-dropdown-item': item.name === _ctx.currentStatusName
          })
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
            class: _normalizeClass(["status", {
              idle: item.number === 0
            }])
          }, null, 2), _createTextVNode(" " + _toDisplayString(item.name), 1)])]),
          _: 2
        }, 1032, ["command", "class"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createElementVNode("span", {
      class: "name-ellipsis",
      title: _ctx.currentStatusName
    }, _toDisplayString(_ctx.currentStatusName), 9, _hoisted_7), _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [[_vShow, !_ctx.disabledSwitch]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(': ' + _ctx.callingNumber), 513), [[_vShow, _ctx.disabledSwitch && _ctx.callingNumber]])])]),
    _: 1
  }, 8, ["onCommand", "disabled"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_phoneBarTimer, {
    class: "ue-pointer",
    ref: "phoneBarPeerTimeRef"
  }, null, 512), _ctx.showDial && !_ctx.hiddenOprate ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: "icon wtue wtue-kuozhan-shouqi-xian",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.toggleDialState && _ctx.toggleDialState(...args))
  })) : _createCommentVNode("", true), !_ctx.showDial && !_ctx.hiddenOprate ? (_openBlock(), _createElementBlock("i", {
    key: 1,
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.toggleDialState && _ctx.toggleDialState(...args)),
    class: "icon wtue wtue-a-hujiaojieting"
  })) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_11, [_createElementVNode("i", {
    class: "wtue wtue-hujiaohuojieting success-back ue-pointer",
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.showInput = !_ctx.showInput, ["stop"]))
  })])], 512), [[_vShow, !_ctx.disabledSwitch]]), _withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.customerInfo.name || _ctx.customerInfo.number), 1), _createElementVNode("div", _hoisted_15, [_createVNode(_component_phoneBarTimer, {
    ref: "phoneBarStatusTimeRef"
  }, null, 512)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.customerInfo.place || '未知地点'), 1), _withDirectives(_createElementVNode("div", {
    class: "tag"
  }, _toDisplayString(_ctx.customerInfo.tag || ''), 513), [[_vShow, _ctx.customerInfo.tag]])])], 512), [[_vShow, _ctx.disabledSwitch && !_ctx.quickState]]), _withDirectives(_createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: _normalizeClass(["quick-state", _ctx.stateType]),
    drag: ""
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.currentStatusName), 1), _createElementVNode("span", null, [_createVNode(_component_phoneBarTimer, {
    ref: "phoneBarQuickStatusTimeRef"
  }, null, 512), _createElementVNode("i", {
    class: "wtue wtue-kuozhan-zhankai-xian",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.switchQuickState(false))
  })])], 2), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, [_ctx.isVisibleBtn('hangup') && _ctx.showHangupBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[5] || (_cache[5] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.hangup && _ctx.hangup(...args), ["stop"]))
  }, _hoisted_21)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[6] || (_cache[6] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.hangup && _ctx.hangup(...args), ["stop"]))
  }, [_ctx.showHangupBtn && (_ctx.hangupState === '2' || _ctx.hangupState === '3' || _ctx.hangupState === '4' || _ctx.hangupState === '5' || _ctx.hangupState === '6' || _ctx.hangupState === '7' || _ctx.hangupState === '10' || _ctx.hangupState === '11' || _ctx.hangupState === '12' || _ctx.hangupState === '13' || _ctx.hangupState === '14' || _ctx.hangupState === '15' || _ctx.hangupState === '16') ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24)) : _createCommentVNode("", true)]))]), _withDirectives(_createElementVNode("div", {
    class: "btn-item accept",
    onClick: _cache[7] || (_cache[7] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.accept && _ctx.accept(...args), ["stop"]))
  }, _hoisted_26, 512), [[_vShow, _ctx.isVisibleBtn('answer')]])])], 512), [[_vShow, _ctx.disabledSwitch]]), _ctx.errorObj.isError ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errorObj.message), 1), _createVNode(_component_el_link, {
    style: {
      "margin-top": "8px"
    },
    underline: false,
    type: "primary",
    onClick: _withModifiers(_ctx.connect, ["stop"])
  }, {
    default: _withCtx(() => [_createTextVNode("刷新状态")]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_29, [_ctx.isVisibleBtn('hangup') && _ctx.showHangupBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn error-back ue-pointer hangup-btn",
    onClick: _cache[8] || (_cache[8] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.hangup && _ctx.hangup(...args), ["stop"]))
  }, [_hoisted_30, _createTextVNode("挂断 ")])) : _createCommentVNode("", true), _ctx.isVisibleBtn('answer') ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn jeiting-btn ue-pointer",
    onClick: _cache[9] || (_cache[9] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.accept && _ctx.accept(...args), ["stop"])),
    style: {
      "min-width": "200px"
    }
  }, [_hoisted_31, _createTextVNode("接听 ")])) : _createCommentVNode("", true)], 512), [[_vShow, _ctx.disabledSwitch && !_ctx.quickState]]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_32, [_ctx.isVisibleBtn('concul') && _ctx.consulSelect ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn btn-middle ue-pointer bak-btn",
    onClick: _cache[10] || (_cache[10] = _withModifiers($event => _ctx.setConsulState(false), ["stop"]))
  }, _hoisted_35)) : _createCommentVNode("", true), _ctx.isVisibleBtn('transfer') && _ctx.transferState ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn btn-middle ue-pointer bak-btn",
    onClick: _cache[11] || (_cache[11] = _withModifiers($event => _ctx.setTransferState(false), ["stop"]))
  }, _hoisted_38)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_39, [_ctx.isVisibleBtn('hold') ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[12] || (_cache[12] = _withModifiers($event => _ctx.holdOrUnHold('1'), ["stop"]))
  }, _hoisted_42)) : _createCommentVNode("", true), _ctx.isVisibleBtn('holdcancel') ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "btn btn-middle ue-pointer flex1",
    onClick: _cache[13] || (_cache[13] = _withModifiers($event => _ctx.holdOrUnHold('2'), ["stop"]))
  }, _hoisted_45)) : _createCommentVNode("", true), _ctx.isVisibleBtn('mute') ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[14] || (_cache[14] = _withModifiers($event => _ctx.muteOrUnMute('1'), ["stop"]))
  }, _hoisted_48)) : _createCommentVNode("", true), _ctx.isVisibleBtn('mutecancel') ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "btn btn-middle ue-pointer flex1",
    onClick: _cache[15] || (_cache[15] = _withModifiers($event => _ctx.muteOrUnMute('2'), ["stop"]))
  }, _hoisted_51)) : _createCommentVNode("", true), _ctx.isVisibleBtn('takeback') ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[16] || (_cache[16] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.resumeConsult && _ctx.resumeConsult(...args), ["stop"]))
  }, _hoisted_54)) : _createCommentVNode("", true), _ctx.isVisibleBtn('concul') && !_ctx.consulSelect ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[17] || (_cache[17] = _withModifiers($event => _ctx.setConsulState(true), ["stop"]))
  }, _hoisted_57)) : _createCommentVNode("", true), _ctx.isVisibleBtn('cancelconcul') ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[18] || (_cache[18] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.cancelConsult && _ctx.cancelConsult(...args), ["stop"]))
  }, _hoisted_60)) : _createCommentVNode("", true), _ctx.isVisibleBtn('endconsul') ? (_openBlock(), _createElementBlock("div", {
    key: 7,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[19] || (_cache[19] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.stopConsult && _ctx.stopConsult(...args), ["stop"]))
  }, _hoisted_63)) : _createCommentVNode("", true), _ctx.isVisibleBtn('concultransfer') ? (_openBlock(), _createElementBlock("div", {
    key: 8,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[20] || (_cache[20] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.consultTransfer && _ctx.consultTransfer(...args), ["stop"]))
  }, _hoisted_66)) : _createCommentVNode("", true), _ctx.isVisibleBtn('threepartycall') ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[21] || (_cache[21] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.threeWayCall && _ctx.threeWayCall(...args), ["stop"]))
  }, _hoisted_69)) : _createCommentVNode("", true), _ctx.isVisibleBtn('transfer') && !_ctx.transferState ? (_openBlock(), _createElementBlock("div", {
    key: 10,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[22] || (_cache[22] = _withModifiers($event => _ctx.setTransferState(true), ["stop"]))
  }, _hoisted_72)) : _createCommentVNode("", true), _ctx.isVisibleBtn('satisfaction') ? (_openBlock(), _createElementBlock("div", {
    key: 11,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[23] || (_cache[23] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.satisfaction && _ctx.satisfaction(...args), ["stop"]))
  }, _hoisted_75)) : _createCommentVNode("", true), _ctx.isVisibleBtn('key') && _ctx.webrtcKeyState ? (_openBlock(), _createElementBlock("div", {
    key: 12,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[24] || (_cache[24] = _withModifiers($event => _ctx.setWebrtcKeyState(false), ["stop"]))
  }, _hoisted_78)) : _createCommentVNode("", true), _ctx.isVisibleBtn('key') && !_ctx.webrtcKeyState ? (_openBlock(), _createElementBlock("div", {
    key: 13,
    class: "btn btn-middle ue-pointer",
    onClick: _cache[25] || (_cache[25] = _withModifiers($event => _ctx.setWebrtcKeyState(true), ["stop"]))
  }, _hoisted_81)) : _createCommentVNode("", true)])]), _ctx.isVisibleBtn('transferoprate') ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", {
    class: "btn btn-middle ue-pointer bak-btn",
    onClick: _cache[26] || (_cache[26] = _withModifiers($event => _ctx.setTransferState(false), ["stop"]))
  }, _hoisted_85), _createVNode(_component_transferOprate)])) : _createCommentVNode("", true), _ctx.isVisibleBtn('consuleoprate') ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", {
    class: "btn btn-middle ue-pointer bak-btn",
    onClick: _cache[27] || (_cache[27] = _withModifiers($event => _ctx.setConsulState(false), ["stop"]))
  }, _hoisted_89), _createVNode(_component_consuleOprate)])) : _createCommentVNode("", true), !_ctx.showConfig && !_ctx.disabledSwitch || _ctx.isVisibleBtn('key') && !_ctx.webrtcKeyState && _ctx.disabledSwitch ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_withDirectives(_createElementVNode("div", _hoisted_91, [_createVNode(_component_el_input, {
    class: "input",
    type: "",
    placeholder: _ctx.showKeyboardPlaceholder ? _ctx.defaultKeyboardPlaceholder : '',
    ref: "input",
    clearable: "",
    modelValue: _ctx.dialoutNumber,
    "onUpdate:modelValue": _ctx.inputChange,
    onKeyup: _withKeys(_ctx.keyDowndialout, ["enter"]),
    onFocus: _cache[28] || (_cache[28] = $event => _ctx.showKeyboardPlaceholder = false),
    onBlur: _cache[29] || (_cache[29] = $event => _ctx.showKeyboardPlaceholder = true)
  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onKeyup"]), _withDirectives((_openBlock(), _createElementBlock("svg", {
    class: "ue-num-keyboard back ue-pointer",
    onClick: _cache[30] || (_cache[30] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.deleteNum && _ctx.deleteNum(...args), ["stop"]))
  }, _hoisted_93, 512)), [[_vShow, _ctx.isVisibleBtn('key')]]), _createElementVNode("div", {
    style: _normalizeStyle([{
      color: !_ctx.showNum ? 'rgb(140, 140, 140)' : 'rgb(28, 146, 233)'
    }, {
      "font-weight": "600",
      "font-size": "16px"
    }])
  }, [_createElementVNode("i", {
    class: "wtue wtue-jianpan ue-pointer",
    onClick: _cache[31] || (_cache[31] = _withModifiers($event => _ctx.showNum = !_ctx.showNum, ["stop"]))
  })], 4), _createElementVNode("div", _hoisted_94, [_createElementVNode("i", {
    class: _normalizeClass(["wtue wtue-hujiaohuojieting success-back ue-pointer", {
      'dialout-disabled': !(_ctx.isVisibleBtn('dialout') && !_ctx.isVisibleBtn('key'))
    }]),
    onClick: _cache[32] || (_cache[32] = _withModifiers($event => _ctx.dialout(_ctx.dialoutNumber, _ctx.isVisibleBtn('dialout') && !_ctx.isVisibleBtn('key')), ["stop"]))
  }, null, 2)])], 512), [[_vShow, _ctx.showInput]]), _ctx.showNum && _ctx.showInput ? (_openBlock(), _createElementBlock("div", _hoisted_95, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyList, (key, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      class: "ue-num-keyboard ue-pointer",
      onClick: _withModifiers($event => _ctx.sendDTMF(key), ["stop"])
    }, _toDisplayString(key), 9, _hoisted_96);
  }), 128)), _createElementVNode("span", {
    class: "ue-num-keyboard ue-pointer star",
    onClick: _cache[33] || (_cache[33] = _withModifiers($event => _ctx.sendDTMF('*'), ["stop"]))
  }, "*"), _createElementVNode("span", {
    class: "ue-num-keyboard ue-pointer",
    onClick: _cache[34] || (_cache[34] = _withModifiers($event => _ctx.sendDTMF('0'), ["stop"]))
  }, "0"), _createElementVNode("span", {
    class: "ue-num-keyboard ue-pointer",
    onClick: _cache[35] || (_cache[35] = _withModifiers($event => _ctx.sendDTMF('#'), ["stop"]))
  }, "#")])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.showConfig && !_ctx.hiddenOprate ? (_openBlock(), _createElementBlock("div", _hoisted_97, [_hoisted_98, _createVNode(_component_formItem, {
    class: "width-full type"
  }, {
    field: _withCtx(() => [_createVNode(_component_el_select, {
      modelValue: _ctx.callConfig.loginType,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => _ctx.callConfig.loginType = $event),
      "popper-append-to-body": true,
      class: "width-full",
      "popper-class": "ue-accept-select",
      onChange: _ctx.changeType
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loginTypeList, one => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: one.value,
          value: one.value,
          label: one.label
        }, null, 8, ["value", "label"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"])]),
    default: _withCtx(() => [_createTextVNode(" 接听方式 ")]),
    _: 1
  }), _ctx.callConfig.loginType === 'WEBRTC' ? (_openBlock(), _createBlock(_component_el_checkbox, {
    key: 0,
    modelValue: _ctx.callConfig.autoAnswer,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => _ctx.callConfig.autoAnswer = $event)
  }, {
    default: _withCtx(() => [_createTextVNode("自动接听")]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true), _ctx.callConfig.autoAnswer && _ctx.callConfig.loginType === 'WEBRTC' ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_createTextVNode(" 振铃 "), _createVNode(_component_input_suffix, {
    suffix: "秒"
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_input_number, {
      style: {
        "width": "120px"
      },
      controls: false,
      modelValue: _ctx.callConfig.autoAnswerTime,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => _ctx.callConfig.autoAnswerTime = $event),
      min: 0,
      "controls-position": "right",
      size: "middle"
    }, null, 8, ["modelValue"]), [[_directive_int]])]),
    _: 1
  }), _createTextVNode(" 后接听 ")])) : _createCommentVNode("", true), _ctx.callConfig.loginType === 'SIP' ? (_openBlock(), _createBlock(_component_formItem, {
    key: 2,
    class: "width-full type"
  }, {
    field: _withCtx(() => [_createVNode(_component_el_select, {
      placeholder: "请选择sip号",
      modelValue: _ctx.callConfig.sipNumber,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => _ctx.callConfig.sipNumber = $event),
      clearable: "",
      class: "width-full",
      "popper-append-to-body": false
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sipNumberList, one => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: one.id,
          value: one.number,
          label: one.number
        }, null, 8, ["value", "label"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])]),
    default: _withCtx(() => [_createTextVNode(" SIP号 ")]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_100, [_createVNode(_component_el_button, {
    class: "cancel",
    onClick: _withModifiers(_ctx.setBack, ["stop"])
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _withModifiers(_ctx.updateLoginType, ["stop"])
  }, {
    default: _withCtx(() => [_createTextVNode("确定")]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true)], 2)), [[_directive_move, {
    position: _ctx.phoneMove.position,
    draggable: _ctx.phoneMove.isDraggable
  }]]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_ctx.callQueueBar ? (_openBlock(), _createBlock(_component_callQueue, {
    key: 0,
    callQueueBarMsg: _ctx.callQueueBarMsg,
    callQueueBarTimer: _ctx.callQueueBarTimer
  }, null, 8, ["callQueueBarMsg", "callQueueBarTimer"])) : _createCommentVNode("", true)])), [[_directive_move, {
    position: _ctx.quickBarMove.position,
    draggable: _ctx.quickBarMove.isDraggable
  }]]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_ctx.networkDelayBar ? (_openBlock(), _createBlock(_component_networkDelay, {
    key: 0,
    networkdelayBarMsg: _ctx.networkdelayBarMsg
  }, null, 8, ["networkdelayBarMsg"])) : _createCommentVNode("", true)])), [[_directive_move, {
    position: _ctx.networkDelayBarMove.position,
    draggable: _ctx.networkDelayBarMove.isDraggable
  }]]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_ctx.openNlsTranslationBar ? (_openBlock(), _createBlock(_component_translationTxt, {
    key: 0,
    openNlsTranslationBarMsg: _ctx.openNlsTranslationBarMsg
  }, null, 8, ["openNlsTranslationBarMsg"])) : _createCommentVNode("", true)])), [[_directive_move, {
    position: _ctx.nlsTranslationBarMove.position,
    draggable: _ctx.nlsTranslationBarMove.isDraggable
  }]])])) : (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))]);
}